var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7f8f8;\n      }\n\n      .cls-2 {\n        fill: #adadad;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #d6d6d6;\n      }\n\n      .cls-5 {\n        fill: #898585;\n      }\n\n      .cls-6 {\n        fill: #f4eded;\n      }\n\n      .cls-7 {\n        fill: #7c7c7c;\n      }\n\n      .cls-8 {\n        fill: #b7b2b2;\n      }\n\n      .cls-9 {\n        fill: #707070;\n      }\n\n      .cls-10 {\n        fill: #d7d7d7;\n      }\n\n      .cls-11 {\n        fill: #f3f2f2;\n      }\n\n      .cls-12 {\n        fill: #aeaeae;\n      }\n\n      .cls-13 {\n        fill: #c9c9c9;\n      }\n\n      .cls-14 {\n        fill: #606060;\n      }\n\n      .cls-15 {\n        fill: #c6c6c6;\n      }\n\n      .cls-16 {\n        fill: #666;\n      }\n\n      .cls-17 {\n        fill: #8a8a8a;\n      }\n\n      .cls-18 {\n        fill: #fcfcfc;\n      }\n\n      .cls-19 {\n        fill: #e2e3e3;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "momtweet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.85,
    y: 198.11,
    width: 78.43,
    height: 53.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 179.35,
    y: 315.75,
    width: 147.05,
    height: 58.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 189.15,
    y: 325.56,
    width: 29.41,
    height: 38.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 228.36,
    y: 305.95,
    width: 19.61,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 218.55,
    y: 256.93,
    width: 19.61,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 213.65,
    y: 271.64,
    width: 19.61,
    height: 9.8,
    transform: "translate(-53.08 500) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 213.65,
    y: 321.66,
    width: 19.61,
    height: 9.8,
    transform: "translate(-103.1 550.02) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 272.47,
    y: 350.07,
    width: 19.61,
    height: 9.8,
    transform: "translate(-72.69 637.25) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 262.67,
    y: 261.84,
    width: 19.61,
    height: 9.8,
    transform: "translate(5.74 539.22) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 196.55,
    y: 286.43,
    width: 122.44,
    height: 48.85,
    rx: 2.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.35,
    y: 252.62,
    width: 80.83,
    height: 48.85,
    rx: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.69,
    y: 374.58,
    width: 19.69,
    height: 9.81,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 275.55,
    y: 198.11,
    width: 33.72,
    height: 9.81,
    rx: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 304.97,
    y: 168.7,
    width: 41.04,
    height: 9.81,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 228.36,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 247.97,
    y: 271.64,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 198.95,
    y: 325.47,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 365.62,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 365.62,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 365.62,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.81,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.81,
    y: 168.69,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.81,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.01,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.01,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 346.01,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.01,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 394.18,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 384.38,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 374.58,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 364.77,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 336.2,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 403.99,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.4,
    y: 394.18,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 335.36,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 325.56,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 315.75,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.4,
    y: 305.95,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.4,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 326.4,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 198.11,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 403.99,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 316.6,
    y: 394.18,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 316.6,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 316.6,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 335.36,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 325.56,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 315.75,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 305.95,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 296.15,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 286.34,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 316.6,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 316.6,
    y: 198.11,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.6,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 403.99,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 394.18,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 384.38,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.79,
    y: 374.58,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.79,
    y: 364.77,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.79,
    y: 354.97,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.79,
    y: 345.17,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.79,
    y: 335.36,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 296.15,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 286.34,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 276.54,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 306.79,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 306.79,
    y: 207.91,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 306.79,
    y: 198.11,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 188.3,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.79,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 394.18,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 296.99,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 276.54,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 266.73,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.99,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.99,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.99,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.99,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 296.99,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 296.99,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 296.99,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 296.99,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 384.38,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.18,
    y: 305.95,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 266.73,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 256.93,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 247.13,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 237.32,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 227.52,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 207.91,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 188.3,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 168.69,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 149.09,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 139.28,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 129.48,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 119.67,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 109.87,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.18,
    y: 100.07,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 277.38,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 256.93,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 247.13,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 277.38,
    y: 237.32,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 277.38,
    y: 227.52,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 277.38,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 100.07,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.38,
    y: 90.26,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 267.58,
    y: 335.36,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 247.13,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.58,
    y: 237.32,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.58,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 267.58,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 267.58,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 267.58,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 267.58,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 100.07,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.58,
    y: 90.26,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 267.58,
    y: 80.46,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 267.58,
    y: 70.66,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 384.38,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 257.77,
    y: 315.75,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 247.13,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.77,
    y: 237.32,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.77,
    y: 227.52,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 257.77,
    y: 207.91,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 188.3,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 257.77,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 257.77,
    y: 168.69,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 257.77,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 257.77,
    y: 149.09,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.77,
    y: 139.28,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 129.48,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 119.67,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 109.87,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 100.07,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 90.26,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.77,
    y: 80.46,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 257.77,
    y: 70.66,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 247.97,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 247.97,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 247.97,
    y: 335.36,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 247.13,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.97,
    y: 237.32,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.97,
    y: 227.52,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 247.97,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 247.97,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 247.97,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 247.97,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 247.97,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 247.97,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 100.07,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 90.26,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 80.46,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 70.66,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 374.58,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 238.16,
    y: 364.77,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 238.16,
    y: 354.97,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 238.16,
    y: 345.17,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 238.16,
    y: 296.15,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 238.16,
    y: 286.34,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 247.13,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 238.16,
    y: 227.52,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 238.16,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 238.16,
    y: 207.91,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 188.3,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 238.16,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 149.09,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 139.28,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 129.48,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 119.67,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 109.87,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 100.07,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 90.26,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 80.46,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 70.66,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 228.36,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 228.36,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 228.36,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 228.36,
    y: 296.15,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 228.36,
    y: 286.34,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 228.36,
    y: 276.54,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 247.13,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 228.36,
    y: 227.52,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 100.07,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 90.26,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 80.46,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.36,
    y: 70.66,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 218.56,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 218.56,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 218.56,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 218.56,
    y: 286.34,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 247.13,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 100.07,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 90.26,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 80.46,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 218.56,
    y: 70.66,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 208.75,
    y: 394.18,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 208.75,
    y: 384.38,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 208.75,
    y: 374.58,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.75,
    y: 364.77,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.75,
    y: 345.17,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 208.75,
    y: 315.75,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 208.75,
    y: 305.95,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.75,
    y: 296.15,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.75,
    y: 286.34,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.75,
    y: 276.54,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 208.75,
    y: 266.73,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.75,
    y: 256.93,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 247.13,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.75,
    y: 237.32,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.75,
    y: 227.52,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 207.91,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 198.11,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 188.3,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 168.69,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 149.09,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 139.28,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 129.48,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 119.67,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 109.87,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 100.07,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 90.26,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 208.75,
    y: 80.46,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 198.95,
    y: 403.99,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 198.95,
    y: 394.18,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 198.95,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 198.95,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.95,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 198.95,
    y: 315.75,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 198.95,
    y: 305.95,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 198.95,
    y: 296.15,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 198.95,
    y: 286.34,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 198.95,
    y: 276.54,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 266.73,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 256.93,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 247.13,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 237.32,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 227.52,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 198.11,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.95,
    y: 100.07,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 198.95,
    y: 90.26,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 198.95,
    y: 80.46,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 189.14,
    y: 403.99,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 189.14,
    y: 394.18,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 384.38,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 189.14,
    y: 374.58,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 189.14,
    y: 364.77,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 189.14,
    y: 354.97,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 189.14,
    y: 335.36,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 315.75,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 305.95,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 296.15,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 286.34,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 276.54,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 189.14,
    y: 247.13,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 237.32,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 227.52,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 217.71,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 207.91,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 198.11,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 188.3,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 178.5,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 168.69,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 158.89,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 149.09,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 139.28,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 129.48,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 119.67,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.14,
    y: 109.87,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 189.14,
    y: 100.07,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 189.14,
    y: 90.26,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 394.18,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 384.38,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 179.34,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 179.34,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 179.34,
    y: 335.36,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 325.56,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 315.75,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 179.34,
    y: 227.52,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 217.71,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 207.91,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 198.11,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 188.3,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 178.5,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 168.69,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 158.89,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 149.09,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 139.28,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.34,
    y: 129.48,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 179.34,
    y: 119.67,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 179.34,
    y: 109.87,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.54,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 169.54,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 169.54,
    y: 345.17,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.54,
    y: 335.36,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.73,
    y: 374.58,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 159.73,
    y: 364.77,
    width: 9.81,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 159.73,
    y: 354.97,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.73,
    y: 345.17,
    width: 9.81,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.93,
    y: 374.58,
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.93,
    y: 364.77,
    width: 9.8,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.93,
    y: 354.97,
    width: 9.8,
    height: 9.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.67b96f2d1c10e02755043c687566798c.svg";
export { ForwardRef as ReactComponent };